export default function gtag() {
    // eslint-disable-next-line prefer-rest-params
    if(window.dataLayer) window.dataLayer.push(arguments);
}
